export default __webpack_public_path__ + "static/media/michael-ramoser.bfcf7b99.jpg";